function r(n) {
  return typeof n == "string" ? n.endsWith("px") ? Number(n.slice(0, n.length - 2)) : Number(n) : n;
}
function t(n) {
  if (n != null)
    return typeof n == "number" ? `${n}px` : n.endsWith("px") ? n : `${n}px`;
}
export {
  r as depx,
  t as pxfy
};
